import { useTranslation } from "react-i18next";
import { Listbox, ListboxItem } from "@nextui-org/react";
import Header from "../../reusable/Header";
import { ArrowForward } from "../../icons/ArrowForward";
import { IdIcon } from "../../icons/IdIcon";
import PoweredBy from "../../reusable/PoweredBy";

const DOC_TYPES = [
  {
    value: "BANK_STATEMENT",
    key: "bankStatement",
  },
  {
    value: "UTILITY_BILL",
    key: "utilityBill",
  },
];

function ProofOfResidenceTypeSelect({ onSelect }) {
  const { t } = useTranslation();

  const handleSubmit = (selected) => {
    const value = selected.values().next().value;
    const docType = DOC_TYPES.find((d) => d.value === value);
    if (docType) {
      onSelect({
        ...docType,
        label: t(`proofOfResidence.typeSelect.docTypes.${docType.key}.label`),
      });
    }
  };

  return (
    <div className="flex h-full flex-col">
      <Header />

      <div className="px-4 pb-3 flex flex-col items-center gap-1">
        <div className="heading text-xl text-center">{t("proofOfResidence.typeSelect.heading")}</div>
        <div className="desc text-sm text-center" style={{color: "var(--urtentic-sdk-subtitle, #737373)"}}>{t("proofOfResidence.typeSelect.subheading")}</div>
      </div>

      <div className="flex-grow overflow-auto px-4">
        <Listbox
          aria-label="Document type selection"
          variant="flat"
          disallowEmptySelection
          selectionMode="single"
          onSelectionChange={handleSubmit}
        >
          {DOC_TYPES.map((doc) => (
            <ListboxItem
              className="py-3"
              key={doc.value}
              showDivider
              description={<span style={{color: "var(--urtentic-sdk-body, #737373)"}}>{t(`proofOfResidence.typeSelect.docTypes.${doc.key}.description`)}</span>}
              startContent={<IdIcon height={24} width={24} stroke="var(--urtentic-sdk-primary, #255CFF)" />}
              endContent={<ArrowForward />}
            >
              <span style={{color: "var(--urtentic-sdk-body, #737373)"}}>
                {t(`proofOfResidence.typeSelect.docTypes.${doc.key}.label`)}
              </span>
            </ListboxItem>
          ))}
        </Listbox>
      </div>

      <div className="flex justify-center p-2">
        <PoweredBy />
      </div>
    </div>
  );
}

export default ProofOfResidenceTypeSelect;
